import "./imprint.page.css";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/language.context";

function ImprintPage() {
    const { t: tr } = useLanguage();

    return (
        <div id="imprint-page" className="default-page">
            <div className="w-100 flex column">
                <div className="legal-page-back">
                    <Link to="/" className="voting-back-link">{tr("ui.voting.backHomePage")}</Link>
                </div>
                <h1>Imprint</h1>
                <p>Information in accordance with § 5 TMG</p>
                <br />
                <p>Card Sports League GmbH</p>
                <p>Kieler Straße 3</p>
                <p>15732 Schulzendorf</p>
                <p>Amtsgericht: Cottbus</p>
                <p>Handelsregister: HRB 16886 CB</p>
                <br />
                <p>Merz Verlag GmbH & Co. KG</p>
                <p>Huyssenallee 105</p>
                <p>45128 Essen</p>
                <br />
                <p>Hana Sports & Entertainment GmbH</p>
                <p>Speichergracht 10</p>
                <p>47051 Duisburg</p>
                <br />
                <p>Represented by</p>
                <p>Norman Wilde (norman@csl.tv),</p>
                <p>Ali Fawaz (ali@csl.tv)</p>
                <br />
                <p>Disclaimer</p>
                <br />
                <p>Accountability for content</p>
                <p>The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents accuracy, completeness or topicality. According to statutory provisions, we are furthermore responsible for our own content on these web pages. In this matter, please note that we are not obliged to monitor the transmitted or saved information of third parties, or investigate circumstances pointing to illegal activity. Our obligations to remove or block the use of information under generally applicable laws remain unaffected by this as per §§ 8 to 10 of the Telemedia Act (TMG).</p>
                <br />
                <p>Accountability for links</p>
                <p>Responsibility for the content of external links (to web pages of third parties) lies solely with the operators of the linked pages. No violations were evident to us at the time of linking. Should any legal infringement become known to us, we will remove the respective link immediately.</p>
                <br />
                <p>Copyright Our web pages and their contents are subject to German copyright law. Unless expressly permitted by law, every form of utilizing, reproducing or processing works subject to copyright protection on our web pages requires the prior consent of the respective owner of the rights. Individual reproductions of a work are only allowed for private use. The materials from these pages are copyrighted and any unauthorized use may violate copyright laws. Quelle: Übersetzungsbüro translate-24h.de</p>
            </div>
        </div>
    );
}

export default ImprintPage;